import { SurveyEngine_Models_RecruitResponse, SurveyEngine_Models_SESurveyConfirmOperation, SurveyEngine_Models_SessionCollection, SurveyEngine_Models_StudyType } from "../../../api";
import { BasicSession } from "./BasicSession";
import { useRecruitCtx } from "../../../Context/RecruitContext";
import { ScheduleState, UserResponse } from "../../../Common";
import { RecruitDecline } from "./RecruitDecline";
import { RecruitConfirmation } from "./RecruitConfirmation";
import { Calendly } from "./Calendly";
import { Cluster } from "./Cluster";
import { useEffect } from "react";
import { Error } from '@progress/kendo-react-labels'
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGlobalCtx } from "../../../Context/GlobalContext";
interface RecruitProps {
    id: number,
    message: string,
    studyName: string,
    studyType: SurveyEngine_Models_StudyType,
    sessions: SurveyEngine_Models_SessionCollection,
    panelistTimeZone: string,
    calendarRecruitUrl: string,
    isAcquireAvalibility : boolean,
    getNextQuestionCommand: (surveySID: string, payLoad: UserResponse, isFirstTime?: boolean) => void,
    getSubmitPendingConfirmation?:(surveySID:string,payLoad:SurveyEngine_Models_RecruitResponse,operation:SurveyEngine_Models_SESurveyConfirmOperation) => void
}

export const RecruitNew = (props: RecruitProps) => {

    const recruitCtx = useRecruitCtx();
    const globalCtx = useGlobalCtx();

    useEffect(()=>{
        //recruitCtxDispatch({ type: "ScheduleState", value: ScheduleState.SCHEDULE });
    },[props]);
    
    return (
        <>
            {

                <>
                    {recruitCtx.recruitError &&         
                        <Error className="theme-validator-error-text font-semibold" direction='start' id={"RecruitError"}>
                            <FontAwesomeIcon icon={faCircleExclamation} className="theme-icon-spacer" />
                            {globalCtx.LangResources.recruitMsg.submitScheduleErrorMsg??"Session(s) you selected could not be scheduled, pls try again"}
                        </Error>
                    }
                    {recruitCtx.currentState === ScheduleState.SCHEDULE &&
                        <>
                            {
                                props.calendarRecruitUrl?.length > 0?
                                <>
                                    <Calendly id={props.id}
                                              message={props.message}
                                              studyName={props.studyName}
                                              calendarRecruitUrl={props.calendarRecruitUrl}
                                              postSurvey={false}
                                              getNextQuestionCommand={props.getNextQuestionCommand}
                                              getSubmitCalendarSchedule={()=>{}}/>
                                </> :
                                <>
                                    {props.studyType === SurveyEngine_Models_StudyType.CLASSIC && <BasicSession
                                        id={props.id}
                                        message={props.message}
                                        studyName={props.studyName}
                                        sessions={props.sessions}
                                        panelistTimeZone={props.panelistTimeZone}
                                        isAcquireAvalibility={props.isAcquireAvalibility}
                                        postSurvey={false}
                                        getSubmitPendingConfirmation={props.getSubmitPendingConfirmation}
                                    />}

                                    {props.studyType === SurveyEngine_Models_StudyType.SESSION_CLUSTER && <Cluster
                                    id={props.id}
                                    message={props.message}
                                    studyName={props.studyName}
                                    sessions={props.sessions}
                                    selectedSession={recruitCtx.selectedSessions}
                                    panelistTimeZone={props.panelistTimeZone}
                                    postSurvey={false}
                                    getSubmitPendingConfirmation={props.getSubmitPendingConfirmation}
                                    />}
                                </>  
                                  
                            }
                        </>
                    }
                    {
                        
                        recruitCtx.currentState === ScheduleState.CONFIRM &&
                        <RecruitConfirmation 
                            id={props.id}
                            studyName={props.studyName}
                            selectedSessions={recruitCtx.selectedSessions}
                            studyType={props.studyType}
                            getNextQuestionCommand={props.getNextQuestionCommand}
                            getSubmitPendingConfirmation={props.getSubmitPendingConfirmation} confirmEnabled={true} cancelEnabled={true} rescheduleEnabled={true}/>
                    }
                    {
                        recruitCtx.currentState === ScheduleState.DECLINE &&
                        <RecruitDecline studyName={props.studyName} studyType={props.studyType} getNextQuestionCommand={props.getNextQuestionCommand}/>
                    }
                </>
            }

        </>

    );
}